import { useEffect, useState } from "react";
/**
 * Defer an action to run later. By calling the returned method, the supplied function
 * will be called with the given parameter on next rerender. A rerender is then triggered.
 *
 * @example
 * // console.log "hi" on next render
 * const deferMsg = useDefer((s: string) => console.log(s));
 *
 * const () => {
 *
 *  return <Something onChange={() => {
 *    // ...
       deferMsg("two");
       console.log("first");
 *  }}
 * }
 */
export function useDefer(fn) {
    const [[shouldRun, v], setInstr] = useState([false, null]);
    useEffect(() => {
        if (shouldRun)
            fn(v);
        setInstr([false, null]);
    }, [shouldRun]);
    return (e) => {
        setInstr([true, e]);
    };
}
